import { ref, onMounted } from 'vue'

const darkMode = ref(false)

export function useDarkMode() {
  const toggleDarkMode = () => {
    darkMode.value = !darkMode.value
    document.documentElement.classList.toggle('dark', darkMode.value)
    localStorage.setItem('darkMode', darkMode.value.toString())
  }

  onMounted(() => {
    const stored = localStorage.getItem('darkMode');
    if (stored === 'true') {
      darkMode.value = true;
    } else {
      // Ensure darkMode.value is false if not explicitly 'true' in storage,
      // or if the item doesn't exist.
      darkMode.value = false;
    }
    
    // After determining initial darkMode.value, apply the class to the document
    if (darkMode.value) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  })

  return { darkMode, toggleDarkMode }
}
